import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from './ui/card';
import { Coins, ChevronRight, Loader2 } from 'lucide-react';

/**
 * Credits Card for Planner Hub
 * NOTE: This component is no longer used on Planner Hub (replaced with ambient indicator)
 * Kept for potential use elsewhere (Account page, etc.)
 * Shows server-truth balance only - no "earned this week" on primary surfaces
 */
const CreditsCard = ({ className = "" }) => {
  const navigate = useNavigate();
  const { 
    creditBalance, 
    hasConfirmedBalance, 
    balanceLoading, 
    refreshCreditBalance 
  } = useAuth();

  // Refresh balance on mount
  useEffect(() => {
    refreshCreditBalance();
  }, [refreshCreditBalance]);

  const handleClick = () => {
    // Navigate to credits page - do not auto-open checkout
    navigate('/account?tab=credits');
  };

  // Don't render if no confirmed balance and not loading
  if (!hasConfirmedBalance && !balanceLoading) return null;

  return (
    <Card 
      className={`cursor-pointer hover:shadow-lg transition-all duration-300 border-2 hover:border-amber-300 group bg-white dark:bg-card ${className}`}
      onClick={handleClick}
      data-testid="credits-card"
    >
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/30 dark:to-orange-900/30 rounded-xl group-hover:scale-110 transition-transform flex-shrink-0">
            {balanceLoading ? (
              <Loader2 className="h-4 w-4 text-amber-600 dark:text-amber-400 animate-spin" />
            ) : (
              <Coins className="h-4 w-4 text-amber-600 dark:text-amber-400" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-bold text-lg text-amber-700 dark:text-amber-400">
                {balanceLoading ? '...' : creditBalance}
              </span>
              <span className="font-medium text-sm text-foreground">
                Credit{creditBalance !== 1 ? 's' : ''}
              </span>
            </div>
            <p className="text-xs text-muted-foreground">View credits</p>
          </div>
          <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditsCard;
